import React, { useState, useEffect } from 'react';
import './Story1.css';

const Story1 = () => {

  return (
    <div className="story-container">
      <p className="story-header">I always wanted to work in museums.</p>
      <p className="story-text">From the dark, magical corners of the Field Museum to the open, airy galleries of the Art Institute, I was lucky to grow up with Chicago’s museum campus as my playground.</p>
    </div>
  )
}

export default Story1;